import { color } from '@ahamove/design-tokens';
import Box from '@ahamove/web-components/lib/Box';
import React from 'react';
import useIsMobile from '@/shared-hooks/useIsMobile';

type Props = {
  children: React.ReactNode;
  offsetTop?: number;
};

export default function StyledReactDateRangeWrapper({
  children,
  offsetTop = 0,
}: Props) {
  const isMobile = useIsMobile();

  return (
    <Box
      sx={(theme) => ({
        mt: `${offsetTop}px !important`,
        '.rdrDefinedRangesWrapper': { display: 'none' },
        '.rdrMonthAndYearWrapper': { pt: 0 },
        '.rdrDateRangePickerWrapper, .rdrCalendarWrapper': {
          width: '100%',
        },
        '.rdrSelected, .rdrStartEdge, .rdrEndEdge': {
          bgcolor: color.primary[50],
          '~ .rdrDayNumber span': {
            color: `${theme.palette.common.white} !important`,
          },
        },
        '.rdrInRange': {
          bgcolor: color.primary[10],
          '~ .rdrDayNumber span': {
            color: `${color.neutral[90]} !important`,
          },
        },
        '.rdrDayToday .rdrDayNumber span:after': {
          bgcolor: color.primary[50],
        },
        '.rdrDayStartPreview, .rdrDayInPreview, .rdrDayEndPreview': {
          borderColor: color.primary[50],
        },
        '.rdrMonthName': {
          textAlign: 'center',
          fontSize: 20,
          lineHeight: 1.4,
          color: color.neutral[90],
          fontWeight: 700,
        },
        '.rdrDateRangeWrapper, .rdrCalendarWrapper': {
          position: 'relative',

          '.rdrMonthAndYearWrapper': {
            width: '100%',
            position: 'absolute',
            top: 0,
            left: 0,
          },

          '.rdrMonth': {
            width: '100%',
            p: isMobile ? 0 : '0 0.833em 1.666em 0.833em',
          },
        },
        '.rdrMonthAndYearPickers': {
          display: 'none',
        },
        '.rdrDayPassive': {
          opacity: 0,
        },
      })}
    >
      {children}
    </Box>
  );
}
